import { isValueFalsey } from '../../internal';
export const formatLabel = (label, required) => {
  const labelValue = label ? `${label}` : '';
  let requiredAnnotation = '';
  if (required === true || required === 'required') {
    requiredAnnotation = '(required)';
  } else if (required === 'optional') {
    requiredAnnotation = '(optional)';
  }
  const separator = isValueFalsey(labelValue) || isValueFalsey(requiredAnnotation) ? '' : ' ';
  return isValueFalsey(labelValue) ? `${requiredAnnotation}` : `${labelValue}${separator}${requiredAnnotation}`;
};